import { Typography } from '@mui/material';
import DrilldownDialog from './DrilldownDialog';
import { KIND_TITLE, dueText, projectDuesTasksUrl, shortTime } from './projectDues';
import { Stack2, fmtDay } from './drilldownCells';

// The popup behind a Project Dues number: the tasks that make it up, one row each - the task, its project, who it is assigned to,
// when it is due and how late (or how long is left). Overdue first, longest late at the top (the server's order).
const names = (r) => (r.assignees || []).map((a) => a.name).join(', ');

const COLUMNS = [
  { key: 'title', label: 'Task', sort: (r) => (r.title || '').toLowerCase(), render: (r) => <Typography variant="body2" fontWeight={600}>{r.title}</Typography>, csv: (r) => r.title },
  { key: 'project', label: 'Project', sort: (r) => (r.projectName || '').toLowerCase(), render: (r) => <Typography variant="body2">{r.projectName || '-'}</Typography>, csv: (r) => r.projectName },
  {
    key: 'assignees', label: 'Assigned to', sort: (r) => names(r).toLowerCase(),
    render: (r) => (r.assignees && r.assignees.length ? <Typography variant="body2">{names(r)}</Typography> : <Typography variant="body2" color="text.secondary">Nobody</Typography>),
    csv: (r) => (names(r) || 'Nobody'),
  },
  {
    key: 'due', label: 'Due', sort: (r) => `${r.dueDate || '9999-12-31'} ${r.dueTime || ''}`,
    render: (r) => (r.dueDate ? <Stack2 top={fmtDay(r.dueDate)} bottom={shortTime(r.dueTime) || null} /> : <Typography variant="body2" color="text.secondary">No due date</Typography>),
    csv: (r) => (r.dueDate ? `${r.dueDate}${r.dueTime ? ` ${shortTime(r.dueTime)}` : ''}` : ''),
  },
  {
    key: 'when', label: 'How late / left', sort: (r) => (r.daysLate !== null && r.daysLate !== undefined ? -r.daysLate : (r.daysLeft ?? 99999)),
    render: (r) => (
      <Typography variant="body2" fontWeight={700} color={r.daysLate !== null && r.daysLate !== undefined ? 'error.main' : 'text.primary'}>{dueText(r)}</Typography>
    ),
    csv: (r) => dueText(r),
  },
];

const searchText = (r) => [r.title, r.projectName, names(r)].filter(Boolean).join(' ').toLowerCase();

// request: { kind, projectId?, userId?, projectName?, userName? }
const ProjectDuesTasksDialog = ({ request, onClose }) => {
  const { kind, projectName, userName } = request;
  const title = KIND_TITLE[kind] || 'Tasks';
  return (
    <DrilldownDialog
      url={projectDuesTasksUrl(request)}
      title={title}
      chips={[userName || projectName || 'All projects', ...(userName && projectName ? [projectName] : [])]}
      dataChips={(d) => [d.asOf ? `As of ${fmtDay(d.asOf)}` : null, d.truncated ? 'Showing the first 1000' : null]}
      columns={COLUMNS}
      searchText={searchText}
      searchLabel="Search these tasks"
      searchPlaceholder="Search task, project or person"
      emptyText="No tasks."
      rowKey={(r) => r.taskId}
      csvName={`${title.replace(/\W+/g, '_')}_${(userName || projectName || 'all').replace(/\W+/g, '_')}.csv`}
      onClose={onClose}
    />
  );
};

export default ProjectDuesTasksDialog;
